import React from "react"
import "./QuoteAuthorImageForeground.scss"

const QuoteAuthorImageForeground = () => <div className="Quote__author-image__foreground"></div>

export default QuoteAuthorImageForeground